/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
  GraphQLObjectType as ObjectType,
  GraphQLInt as IntType,
  GraphQLString as StringType,
  GraphQLNonNull as NonNull,
} from 'graphql';

import PropTypes from 'prop-types';

const UserType = new ObjectType({
  name: 'User',
  fields: {
    member_id: { type: new NonNull(IntType) },
    name_title_id: { type: IntType },
    first_name: { type: new NonNull(StringType) },
    last_name: { type: new NonNull(StringType) },
    email: { type: new NonNull(StringType) },
    birthday: { type: new NonNull(StringType) },
    country_of_residence: { type: StringType },
    country_of_residence_code: { type: StringType },
    prefer_lang: { type: StringType },
    phoneCountry: {
      type: new ObjectType({
        name: 'PhoneCountry',
        fields: {
          country: { type: new NonNull(StringType) },
          phone: { type: new NonNull(StringType) },
        },
      }),
    },
    loyalty_number: { type: new NonNull(StringType) },
  },
});

UserType.shape = () =>
  PropTypes.shape({
    id: PropTypes.number,
    name_title_id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    birthday: PropTypes.string,
    country_of_residence_code: PropTypes.string,
    prefer_lang: PropTypes.string,
    phoneCountry: PropTypes.shape({
      country: PropTypes.string,
      phone: PropTypes.string,
    }),
    loyalty_number: PropTypes.string,
  });

export default UserType;
